import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { useSite } from "@/context/SiteContext";
import { searchAll } from "@/lib/search";

export default function SearchDialog({ open, onOpenChange }) {
  const site = useSite();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const results = site?.data ? searchAll(site, q) : [];
  const groups = results.reduce((acc, r) => ({ ...acc, [r.type]: [...(acc[r.type] || []), r] }), {});
  const go = (to) => { onOpenChange(false); setQ(""); nav(to); };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange} shouldFilter={false}>
      <CommandInput placeholder="Pesquisar atividades, organizações, locais…" value={q} onValueChange={setQ} data-testid="global-search-input"
        onKeyDown={(e) => { if (e.key === "Enter" && q.trim().length > 1 && !results.length) go(`/pesquisa?q=${encodeURIComponent(q)}`); }} />
      <CommandList>
        <CommandEmpty>{q.length < 2 ? "Escreva pelo menos 2 letras." : "Sem resultados."}</CommandEmpty>
        {Object.entries(groups).map(([type, items]) => (
          <CommandGroup key={type} heading={type}>
            {items.slice(0, 6).map((r) => (
              <CommandItem key={r.id} value={r.id} onSelect={() => go(r.to)} data-testid={`search-result-${r.id}`} className="min-h-[44px]">{r.title}</CommandItem>
            ))}
          </CommandGroup>
        ))}
        {results.length > 0 && (
          <CommandGroup>
            <CommandItem value="ver-todos" onSelect={() => go(`/pesquisa?q=${encodeURIComponent(q)}`)} data-testid="search-see-all">Ver todos os resultados ({results.length})</CommandItem>
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
